import Exception from "./Exception";

export default class ApiException extends Exception {
  error = null;

  constructor(axiosError, message = "") {
    super(message, "API");
    this.name = "ApiException";
    this.error = axiosError;
    if (!this.message) {
      this.setMessageFromResponse();
    }
  }

  setMessageFromResponse() {
    const { error } = this;
    if (!error) {
      this.message = "An Unknown error occured";
    } else if (error.response) {
      const { response } = error;
      const definedMessage = response?.data?.Message || response?.data?.message;
      if (definedMessage) {
        this.message = definedMessage;
      } else if (response.status === 401) {
        this.message = `Unauthorized Operation.`;
      } else if (response.status === 400) {
        this.message = "Unexpected Error From API Services";
      } else if (response.status === 404) {
        this.message = "Unexpected Error From API Services; Service Not Found.";
      } else if (response.status === 500) {
        this.message = `Unexpected internal error occured. Please contact system administrator.`;
      } else if (response.status === 502) {
        this.message = `The proxy server received an invalid response from an upstream server. (502 Bad Gateway)`;
      } else if (response.status === 501) {
        this.message = `Work in progress.`;
      } else {
        this.message = `${response.status}: ${response.statusText || "An unexpected error"}`;
      }
    } else {
      this.message = `An unexpected error occured - ${error.message}`;
    }
  }

  getStatus() {
    if (this.error) {
      return this.error?.response?.status ?? null;
    }
    return null;
  }
}
